import { motion } from "framer-motion";
import CountUp from "react-countup";
import { ArrowRight } from "lucide-react";

export const Reveal = ({ amount, onContinue }) => (
  <div data-testid="reveal-step" className="flex min-h-[70vh] flex-col justify-center">
    <motion.p
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="text-sm font-semibold uppercase tracking-[0.2em] text-zinc-500"
    >
      Companies earn about
    </motion.p>

    <motion.div
      initial={{ scale: 0.7, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", stiffness: 120, damping: 14 }}
      className="my-3 flex items-baseline gap-1"
    >
      <span className="font-display text-3xl font-bold text-aquaink sm:text-4xl">A$</span>
      <span
        data-testid="reveal-amount"
        className="text-gradient font-display text-6xl font-black tracking-tighter sm:text-7xl"
      >
        <CountUp end={amount} duration={2.6} separator="," />
      </span>
    </motion.div>

    <motion.p
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.6 }}
      className="max-w-xs text-lg text-zinc-600"
    >
      from <span className="font-semibold text-zinc-900">your</span> personal data — every single
      year.
    </motion.p>

    <motion.button
      data-testid="reveal-continue-btn"
      onClick={onContinue}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 2.4 }}
      whileTap={{ scale: 0.96 }}
      className="mt-10 flex items-center justify-center gap-2 rounded-full bg-lime px-7 py-4 font-display text-base font-bold text-black shadow-[0_10px_30px_rgba(204,255,0,0.5)]"
    >
      See the breakdown <ArrowRight className="h-5 w-5" strokeWidth={2.5} />
    </motion.button>
  </div>
);
